import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'lem-toast-outlet',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-outlet.component.html',
  styleUrl: './toast-outlet.component.scss',
})
export class ToastOutletComponent {
  private readonly notifications = inject(NotificationService);
  readonly items = this.notifications.notifications;

  dismiss(id: number): void {
    this.notifications.dismiss(id);
  }
}
